import { Injectable } from '@angular/core';
import { PortalApi, ResponseAgreementDto } from 'generated/apex-rest';
import { restAxiosConfig } from '../../../../../apex/src/app/utils/rest-axios-config';

@Injectable()
export class PortalAgreementService {
  private readonly portalApi = new PortalApi(restAxiosConfig());

  async getAllAgreements(): Promise<ResponseAgreementDto[]> {
    const response = await this.portalApi.portalAgreementControllerReadCollection();

    return response.data.Collection || [];
  }

  async getAgreementById(agreementId: number): Promise<ResponseAgreementDto> {
    const response = await this.portalApi.portalAgreementControllerRead(agreementId);

    return response.data.Entity;
  }
}
